import {useMemo} from 'preact/hooks';

import {readShopifyFeatures} from './helpers';

export function useShopifyFeatures() {
  return useMemo(() => readShopifyFeatures(), []);
}
